const lbanTenant = {
  clientId: "f9df6cfc-2b4c-4654-88e1-c9acea243247",
  authority: `https://login.microsoftonline.com/39dab133-5d7b-4bec-8eca-7f89b173e27f`,
};

const mtnTenant = {
  clientId: "9fd74419-b276-444e-9695-be9fc1747fac",
  authority: `https://login.microsoftonline.com/55fbc70a-e57f-4db4-9a04-388a9338ca95`,
};

// export const msalConfig = {
//   auth: {
//     clientId: oblTenant.clientId,
//     authority: oblTenant.authority,
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: false,
//   },
// };
export const getMsalConfig = (environment: any) => {
  if (environment === "MTN") {
    return {
      auth: {
        clientId: mtnTenant.clientId,
        authority: mtnTenant.authority,
        redirectUri: window.location.origin, // this becomes https://myapp.company.com
        postLogoutRedirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  } else {
    return {
      auth: {
        clientId: lbanTenant.clientId,
        authority: lbanTenant.authority,
        redirectUri: window.location.origin, // this becomes https://myapp.company.com
        postLogoutRedirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  }
};
